'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("directoryEditionPopinController", function ($scope) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.saveAndClose = function () {
    _.extend(originalDocument, $scope.document);
    $scope.$close(originalDocument);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/inventaire/documents/directoryEditionPopin.js
// module id = 2825
// module chunks = 13